import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CalendarDays, Newspaper } from "lucide-react";
import { fileSrc } from "@/lib/api";

export const fmtPostDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("ka-GE", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export default function BlogCard({ post, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: index * 0.06 }}
      className="card-lux overflow-hidden flex flex-col h-full group"
      data-testid={`blog-card-${post.slug}`}
    >
      <Link to={`/blog/${post.slug}`} className="flex flex-col h-full">
        <div className="relative h-48 overflow-hidden bg-[#0D0F14]">
          {post.cover_url ? (
            <img
              src={fileSrc(post.cover_url)}
              alt={`${post.title} — taxipark.ge ბლოგი`}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-600">
              <Newspaper className="w-9 h-9" />
            </div>
          )}
        </div>
        <div className="p-6 flex flex-col flex-1">
          <p className="text-xs text-gray-500 flex items-center gap-1.5">
            <CalendarDays className="w-3.5 h-3.5 text-[#D4AF37]" /> {fmtPostDate(post.created_at)}
          </p>
          <h2 className="text-lg font-semibold text-white mt-2 leading-snug group-hover:text-[#E5C378] transition-colors">{post.title}</h2>
          {post.excerpt && <p className="text-sm text-gray-500 mt-2 leading-relaxed line-clamp-3">{post.excerpt}</p>}
          <span className="inline-flex items-center gap-1.5 text-sm text-[#E5C378] mt-auto pt-4">
            წაიკითხე <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </motion.article>
  );
}
